import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransactionLogsRoutingModule } from './transaction-logs-routing.module';
import { TransactionLogsComponent } from './transaction-logs.component';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [TransactionLogsComponent],
  imports: [
    CommonModule,
    GridModule,
    TransactionLogsRoutingModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    FormsModule,
    MyDatePickerModule,
    NgSelectModule,
  ],
  providers:[ PageService,
    SortService,
    ResizeService,
    FilterService,
    ColumnChooserService]
})
export class TransactionLogsModule { }
